type DRFError = {
  code: string;
  detail: string;
  attr: string;
};

/**
 * Attempts to detect if the error contains the "trip has been invoiced" error,
 * and if so, produces a more user friendly error message.
 */
export function formatInvoiceValidationError(error: any) {
  if (
    !(
      typeof error === 'object' &&
      error.status === 400 &&
      error.data.type === 'validation_error' &&
      error.data.errors.length > 0
    )
  ) {
    return null;
  }

  // Verify that the error is a "trip has been invoiced" error
  const tripInvoicedError = error.data.errors.find(
    (err: DRFError) => err.code === 'invalid' && err.detail === 'trip_invoiced'
  );

  if (!tripInvoicedError) {
    return null;
  }

  // Join the error message list into an object
  const errorMessage = error.data.errors.reduce(
    (acc: Record<string, string>, err: DRFError) => {
      acc[err.attr] = err.detail;
      return acc;
    },
    {}
  );

  return errorMessage as Record<string, string>;
}
